import React, { useEffect } from 'react'
import { CurrentCash } from '_gql'

import { FormattedMessage } from '@divvy-web/i18n'

import GoodFitQuestionContent from '@sputnik/pages/PreApplicationPages/GoodFitSurveyPage/GoodFitWizardForm/GoodFitQuestionContent'
import { useWebTracking } from '@sputnik/tracking/WebTrackingContext'

const CurrentCashQuestion = () => {
  const currentCashOptions = [
    {
      id: CurrentCash.LESS_THAN_25K,
      key: CurrentCash.LESS_THAN_25K,
      label: (
        <FormattedMessage
          defaultMessage='less than $25k'
          id='sputnik.CurrentCashQuestion__t5YfZw'
        />
      ),
      value: CurrentCash.LESS_THAN_25K,
    },
    {
      id: CurrentCash.BETWEEN_25K_AND_100K,
      key: CurrentCash.BETWEEN_25K_AND_100K,
      label: (
        <FormattedMessage
          defaultMessage='$25k-$100k'
          id='sputnik.CurrentCashQuestion__ToBUHD'
        />
      ),
      value: CurrentCash.BETWEEN_25K_AND_100K,
    },
    {
      id: CurrentCash.BETWEEN_100K_AND_300K,
      key: CurrentCash.BETWEEN_100K_AND_300K,
      label: (
        <FormattedMessage
          defaultMessage='$100k-$300k'
          id='sputnik.CurrentCashQuestion__CR0cRu'
        />
      ),
      value: CurrentCash.BETWEEN_100K_AND_300K,
    },
    {
      id: CurrentCash.OVER_300K,
      key: CurrentCash.OVER_300K,
      label: (
        <FormattedMessage
          defaultMessage='$300k+'
          id='sputnik.CurrentCashQuestion__IKXqS2'
        />
      ),
      value: CurrentCash.OVER_300K,
    },
  ]

  const { track } = useWebTracking()

  /* tracking start */

  useEffect(() => {
    track('se_signup__qualification_check_cash_balance__presented')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  /* tracking end */

  return (
    <GoodFitQuestionContent
      inputName='currentCash'
      options={currentCashOptions}
      question={
        <FormattedMessage
          defaultMessage='What’s the current cash balance in your company’s bank account?'
          id='sputnik.CurrentCashQuestion__6IcGQ5'
        />
      }
    />
  )
}

export default CurrentCashQuestion
